<template>
  <div
    v-if="routeContentspot && validContentspot"
    class="ContentspotView a-cover z-0 overflow-hidden flex justify-center items-center"
  >
    <!-- Overlay -->
    <div
      class="a-cover overflow-hidden"
      :class="`bg-${overlayStyles.bg_color} opacity-${overlayStyles.opacity}`"
    />
    <router-link
      :to="closeRouteTo"
      :class="closeClasses"
      :title="htmlDecode(closeTitle)"
    >
      <SvgIcon
        icon="cross"
        class="w-6 h-6"
      />
    </router-link>
    <div class="relative w-full max-h-full overflow-auto scrolling-touch">
      <div class="my-8 px-4">
        <div :class="bodyClasses">
          <Article
            v-if="routeContentspot.type === 'article'"
            :post="routeContentspot"
          />
          <Gallery
            v-else-if="routeContentspot.type === 'gallery'"
            :post="routeContentspot"
          />
          <Video
            v-else-if="routeContentspot.type === 'video'"
            :post="routeContentspot"
          />
          <MediaTitle :post="routeContentspot" />
          <div
            v-if="routeContentspot.body"
            class="tiny-mce mt-6"
            v-html="wysiwygFilter(routeContentspot.body)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import Article from '@/components/Article.vue'
import Gallery from '@/components/Gallery.vue'
import Video from '@/components/Video.vue'
import MediaTitle from '@/components/MediaTitle.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Contentspot',

  components: {
    SvgIcon,
    Article,
    Gallery,
    Video,
    MediaTitle
  },

  computed: {
    ...mapGetters([
      'routeName',
      'routeContentspot',
      'myStore'
    ]),
    validContentspot() { return ['article', 'gallery', 'video'].includes(this.routeContentspot.type) },
    mediaStyles() { return this.myStore(['styles', 'media_screens']) ?? {} },
    overlayStyles() { return this.mediaStyles.background ?? {} },
    closeRouteTo() { return { name: this.routeName.replace('contentspot', 'panorama') } },
    closeClasses() {
      // Data
      const settings = this.mediaStyles.close_button ?? {}
      const focusStyles = settings.focus ?? {}
      const hoverStyles = settings.hover ?? {}
      // Return
      return [
        'absolute right-4 top-4 w-12 h-12 z-1',
        'flex-c',
        `border-${settings.border_width ?? 1}`,
        `border-${settings.border_color} focus:border-${focusStyles.border_color} lg:hover:border-${hoverStyles.border_color}`,
        `rounded-bl-${settings.border_radius ?? 5}`,
        `bg-${settings.bg_color} focus:bg-${focusStyles.bg_color} lg:hover:bg-${hoverStyles.bg_color}`,
        `fill-${settings.fill_color} focus:fill-${focusStyles.fill_color} lg:hover:fill-${hoverStyles.fill_color}`,
        'transition-colors duration-500 ease-in-out',
        'focus:outline-none'
      ]
    },
    closeTitle() { return this.myStore(['labels', 'media_screens', 'close_button', 'btn_title']) ?? 'Close window' },
    bodyClasses() {
      const bodyStyles = this.myStore(['styles', 'media_screens', 'body_copy']) ?? {}
      return [
        'w-full',
        'max-w-200',
        'mx-auto',
        `text-${bodyStyles.text_color}`,
      ]
    }
  },
}
</script>

